import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DesignService, ItemLogService } from 'src/app/state';

@Component({
  selector: 'em-item-log',
  templateUrl: './item-log.component.html',
  standalone: false,
})
export class ItemLogComponent implements OnInit, OnDestroy {
  public readonly itemLogs$ = this.itemLogService.itemLogs$;
  public readonly error$ = this.itemLogService.error$;
  public readonly isLoading$ = combineLatest([
    this.designService.loading$,
    this.itemLogService.loading$,
  ]).pipe(map(([designLoading, itemLogLoading]) => designLoading || itemLogLoading));

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly itemLogService: ItemLogService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(switchMap((designId) => this.itemLogService.loadByDesignId(designId)))
        .subscribe()
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
